import React, { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { SkeletonTheme } from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const Main = lazy(() => import('./views/Main'));
const NotFound = lazy(() => import('./views/NotFound'));
const FullScreenVideo = lazy(() => import('./views/FullScreenVideo'));

export const App: React.FC = () => (
  <div className="App flex column">
    <SkeletonTheme baseColor="#ffffff" highlightColor="#f8f9fb">
      <Suspense fallback={React.Fragment}>
        <Routes>
          <Route path="/video/:shareCode" element={<Main />} />
          <Route path="/videos/:shortlistShareCode" element={<Main />} />
          <Route path="/embed/:shareCode" element={<FullScreenVideo />} />
          <Route path="/player" element={<FullScreenVideo />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </SkeletonTheme>
  </div>
);
